/**
 * Created by AlexanderC on 3/7/16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComplexDriver = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AbstractDriver2 = require('./AbstractDriver');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let ComplexDriver = exports.ComplexDriver = function (_AbstractDriver) {
  _inherits(ComplexDriver, _AbstractDriver);

  /**
   * @param {AbstractDriver|*} drivers
   */
  function ComplexDriver() {
    _classCallCheck(this, ComplexDriver);

    var _this = _possibleConstructorReturn(this, (ComplexDriver.__proto__ || Object.getPrototypeOf(ComplexDriver)).call(this));

    for (var _len = arguments.length, drivers = Array(_len), _key = 0; _key < _len; _key++) {
      drivers[_key] = arguments[_key];
    }

    _this._drivers = drivers;
    return _this;
  }

  /**
   * @returns {AbstractDriver[]|*[]|*}
   */


  _createClass(ComplexDriver, [{
    key: 'add',


    /**
     * @param {AbstractDriver|*} driver
     * @returns {ComplexDriver}
     */
    value: function add(driver) {
      this._drivers.push(driver);

      return this;
    }

    /**
     * @private
     */

  }, {
    key: '_load',
    value: function _load() {
      for (var _len2 = arguments.length, drivers = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        drivers[_key2] = arguments[_key2];
      }

      this._drivers = this._drivers.concat(drivers);

      this._loadDriversQueue([].concat(this._drivers));
    }

    /**
     * @param {AbstractDriver[]|*[]} drivers
     * @param {Error[]|String[]|*[]} errors
     * @private
     */

  }, {
    key: '_loadDriversQueue',
    value: function _loadDriversQueue(drivers) {
      let errors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      if (drivers.length <= 0) {
        this.fail(`All drivers failed to load: ${errors.join('; ')}`);

        return;
      }

      let driver = drivers.shift();

      driver.onLoadedCb(config => {
        this.loaded(config);
      });

      driver.onFailCb(error => {
        errors.push(error.toString());

        this._loadDriversQueue(drivers, errors);
      });

      driver.load();
    }
  }, {
    key: 'drivers',
    get: function get() {
      return this._drivers;
    }
  }]);

  return ComplexDriver;
}(_AbstractDriver2.AbstractDriver);


//////////////////
// WEBPACK FOOTER
// ../~/deep-kernel/lib.compiled/Config/Driver/ComplexDriver.js
// module id = 388
// module chunks = 0